import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home flex" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "woosung_join_app", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("회원 가입")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("아이디 찾기")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("비밀번호 찾기")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("개인정보 동의 임시")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "/join" }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "/search/id" }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "/search/pw" }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "/doc_web/docCheck" }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _createTextVNode(" " + _toDisplayString(_ctx.API), 1)
    ])
  ]))
}